import type { SessionStepModule } from '../types';
import { TemplateDetail } from './TemplateDetail';
import { TemplateStepRunner } from './TemplateStepRunner';
import { isTemplateStep } from './template.utils';

// Document Template step — generates a document from the tenant's template, filled
// with what earlier steps verified. The only module that calls no provider.
export const templateStepModule: SessionStepModule = {
  key: 'template',
  matches: isTemplateStep,
  Runner: TemplateStepRunner,
  Detail: TemplateDetail,
};
